export const ROUTES = {
  root: '/',
  login: '/login',
  submissions: '/submissions',
  dashboard: '/dashboard',
  packages: '/packages',
  application: '/application',
  profile: '/profile',
  account: '/account',
  settings: '/settings',
  notFound: '*',
};


